module.exports = __webpack_public_path__ + "static/media/City.11c51879.svg";